import { currentLanguageIdVar } from 'graphql/reactive'

import useSelectMarket from 'hooks/useSelectMarket'

export default function useIsProfileDefaultLanguage(
  profileMarketId: string,
  strict = false,
): boolean {
  const currentLanguageId = currentLanguageIdVar()

  const selectMarket = useSelectMarket()
  const profileMarket = selectMarket({ marketId: profileMarketId })
  const profileLanguageId = profileMarket.selectedMarket?.defaultLanguage.id

  if (strict) return currentLanguageId === profileLanguageId

  // split region off language code so eg. en-us & en-aus are equivilent
  return currentLanguageId.split('-')[0] === profileLanguageId?.split('-')[0]
}
